module.exports = __webpack_public_path__ + "img/allto.0cfeb20f.png";